import { render, staticRenderFns } from "./Stock-minimo.vue?vue&type=template&id=76fed71c&scoped=true"
import script from "./Stock-minimo.vue?vue&type=script&lang=js"
export * from "./Stock-minimo.vue?vue&type=script&lang=js"
import style0 from "./Stock-minimo.vue?vue&type=style&index=0&id=76fed71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fed71c",
  null
  
)

export default component.exports